var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as _ from "lodash";
import { Messages } from 'primereact/messages';
import * as React from "react";
import { connect } from "react-redux";
import * as ProductFactory from "../../classes/definitions/product/product";
import ApiRequests from "../../classes/http/ApiRequests";
import HttpRequests from "../../classes/http/HttpRequests";
import CategoryProductsList from '../../components/categoryProducts/ProductsList/CategoryProductsList';
import AppRoutes from '../../config/appRoutes';
import ProductsReduxProps from "../Products/ProductsReduxProps";
var CategoryProducts = /** @class */ (function (_super) {
    __extends(CategoryProducts, _super);
    function CategoryProducts() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.messages = null;
        _this.queryParams = { pageNumber: 1, filter: '' };
        _this.state = {
            data: [],
            meta: null,
            delaySearchTimer: null,
            categoryId: null
        };
        _this.getId = function () {
            return _this.props.match.params.id || null;
        };
        _this.getAllProducts = function (page) {
            if (page === void 0) { page = 1; }
            _this.api.getCategoryProducts(_this.getId(), page)
                .then(function (response) {
                var products = ProductFactory.createProducts(response.data);
                var meta = _.get(response, 'data.meta', null);
                _this.setState({ data: products, meta: meta });
            })
                .catch(function (error) {
                _this.http.handleError(error, _this.messages, 'Не можахме да заредим списъка с продукти', _this.props.history);
            });
        };
        _this.toNewProduct = function () {
            _this.props.history.push(AppRoutes.product.path);
        };
        _this.search = function (event) {
            clearTimeout(_this.state.delaySearchTimer);
            var searchVal = event.target.value;
            var categoryId = _this.props.match.params.id;
            if (searchVal) {
                _this.setState({
                    delaySearchTimer: setTimeout(function () {
                        _this.api.searchProductsCategory(searchVal, categoryId)
                            .then(function (response) {
                            var orders = ProductFactory.createProducts(response.data);
                            _this.setState({ data: orders, meta: null });
                        })
                            .catch(function (error) {
                            _this.http.handleError(error, _this.messages, 'Не можахме да заредим списъка с продукти', _this.props.history);
                        });
                    }, 1000)
                });
                return;
            }
            _this.getAllProducts();
        };
        return _this;
    }
    CategoryProducts.prototype.componentDidMount = function () {
        this.getAllProducts();
    };
    CategoryProducts.prototype.render = function () {
        var _this = this;
        var _a = this.state, data = _a.data, meta = _a.meta;
        return (React.createElement("div", { className: "container-fluid" },
            React.createElement("div", { className: "animated fadeIn" },
                React.createElement("h1", { className: "display-3" }, "\u041F\u0440\u043E\u0434\u0443\u043A\u0442\u0438"),
                React.createElement("hr", null),
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-md-12" },
                        React.createElement(Messages, { ref: function (el) { _this.messages = el; } }),
                        React.createElement(CategoryProductsList, { gridData: data, meta: meta, getAllProducts: function (page) { return _this.getAllProducts(page); }, search: this.search }))))));
    };
    return CategoryProducts;
}(React.Component));
export default connect(null, ProductsReduxProps.mapDispatchToProps)(CategoryProducts);



//////////////////
// WEBPACK FOOTER
// ./src/views/Categories/categoryProducts.tsx
// module id = 334
// module chunks = 0